import { configureStore } from "@reduxjs/toolkit";
import { consoleApiSlice } from "./api/console/consoleApiSlice";
import { issueDetectionApiSlice } from "./api/IssueDetection/IssueDetectionApiSlice";
import { platformApiSlice } from "./api/platform/platformApiSlice";
import { consoleWebsitesReducer } from "./api/console/consoleWebsitesApiSlice";
import { agentMemoryReducer } from "./api/console/agentMemoryApiSlice";
import { controlTowerReducer } from "./api/console/agenticRunsApiSlice";
import authReducer from "./authSlice";

export const store = configureStore({
  reducer: {
    [consoleApiSlice.reducerPath]: consoleApiSlice.reducer,
    [platformApiSlice.reducerPath]: platformApiSlice.reducer,
    [issueDetectionApiSlice.reducerPath]: issueDetectionApiSlice.reducer,
    consoleWebsites: consoleWebsitesReducer,
    agentMemory: agentMemoryReducer,
    controlTower: controlTowerReducer,
    auth: authReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(consoleApiSlice.middleware)
      .concat(platformApiSlice.middleware)
      .concat(issueDetectionApiSlice.middleware),
  devTools: process.env.NODE_ENV !== "production",
});
